import type { AnswerDetailResponse } from '@coorum-research/shared-common/api-response'
import type { CampaignSimpleResponse } from '@coorum-research/shared-common/api-response/popup.schema'
import type { RefObject } from 'react'
import { Sheet } from '@coorum-research/core/src/components/Sheet'
import { SurveyAnswerCampaignClose } from '@coorum-research/core/src/components/SurveyAnswerCampaignClose'
import { useState } from 'react'
import { SurveyAppAnswerUpdate } from './SurveyAppAnswerUpdate'
import { ThanksPage } from './ThanksPage'

export type AnswerUpdatePageMode = 'survey' | 'thanks'

type Props = {
  campaign: CampaignSimpleResponse | null | undefined
  answerDetail: AnswerDetailResponse
  containerRef: RefObject<HTMLDivElement | null>
  open: boolean
  setOpen: (open: boolean) => void
}

export function AnswerDetailUpdateSheet({
  campaign,
  answerDetail,
  containerRef,
  open,
  setOpen,
}: Props) {
  const [answerPageMode, setAnswerPageMode] = useState<AnswerUpdatePageMode | null>('survey')
  const [launcherContentId, setLauncherContentId] = useState<string | null>(null)
  const [isInterruptOpen, setInterruptOpen] = useState(false)

  /**
   * confirm dialog(interrupt)でconfirmすると、sheetも閉じる
   */
  const handleCloseConfirm = () => {
    setInterruptOpen(false)
    setOpen(false)
    setAnswerPageMode('survey')
  }

  /**
   * アンケートをclose eventを受け取る
   * すぐ閉じないでconfirm dialog(interrupt)を表示する
   * campaignDataが取得できていない場合は、そのまま閉じる
   * campaignDataがある場合には、修正の再開の中断なのでconfirm dialogを表示する
   */
  const handleCloseSheet = (open: boolean) => {
    if (open) {
      return
    } else {
      // closeの時
      if (!campaign) {
        // キャンペーンが無い時 -> そのまま閉じる
        handleCloseConfirm()
      } else {
        if (answerPageMode === 'survey') {
          // キャンペーンがあり、修正途中なら -> interrupt dialogを表示
          setInterruptOpen(true)
        } else {
          // キャンペーンがあり、修正完了なら -> そのまま閉じる
          handleCloseConfirm()
        }
      }
    }
  }

  return (
    <Sheet.Root open={open} onOpenChange={handleCloseSheet}>
      <Sheet.Portal container={containerRef?.current}>
        <Sheet.Overlay />
        <Sheet.Content className="h-full overflow-y-auto bg-white">
          <Sheet.Title hidden>回答の編集</Sheet.Title>
          <Sheet.Description hidden>回答を編集します</Sheet.Description>
          {!campaign && (
            <SurveyAnswerCampaignClose
              onClose={handleCloseConfirm}
            />
          )}
          {campaign && (
            <>
              {answerPageMode === 'survey' && (
                <SurveyAppAnswerUpdate
                  answer={answerDetail}
                  campaign={campaign}
                  surveyId={campaign.surveyId ?? ''}
                  onComplete={(nextLaunchContentId: string | null) => {
                    setLauncherContentId(nextLaunchContentId)
                    setAnswerPageMode('thanks')
                  }}
                  containerRef={containerRef}
                  isInterrupt={isInterruptOpen}
                  setIsInterrupt={setInterruptOpen}
                  onClose={handleCloseConfirm}
                />
              )}
              {answerPageMode === 'thanks' && (
                <ThanksPage
                  openedFrom="update"
                  // popup={popup}
                  campaign={campaign}
                  launcherContentId={launcherContentId}
                  onClickButton={() => handleCloseConfirm()}
                />
              )}
            </>
          )}
        </Sheet.Content>
      </Sheet.Portal>
    </Sheet.Root>
  )
}
